import { Box } from "@chakra-ui/react";
import {
  ColorIcon,
  colors,
  GoiLogo,
  HLine,
  HStack,
  NextLink,
  VStack,
} from "goi_common";

export default function GuideFooter() {
  return (
    <VStack
      width="100%"
      alignItems="center"
      gap="20px"
      padding="0 0 40px"
      margin="0 0 60px"
    >
      <HLine
        width="100%"
        height="1px"
        color={colors.gray300}
        margin="0 0 40px"
      />
      <GoiLogo />
      <Box className="gray900">기업 조사지원의 모든 것, 고이BIZ</Box>
      <NextLink
        href="/content/"
        css={{
          padding: "9px 25px",
          background: colors.gray100,
          borderRadius: "5px",
        }}
      >
        <HStack alignItems="center" gap="8px">
          <ColorIcon
            color={colors.warmGray850}
            name="icon-arrow-right-circle-mono"
            size={18}
            css={{ transform: "rotate(180deg)" }}
          />
          <Box className="subtitle_14_sb" color={colors.warmGray850}>
            목록으로 돌아가기
          </Box>
        </HStack>
      </NextLink>
    </VStack>
  );
}
